import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Team from "./pages/Team";
import HomeFeed from "./pages/HomeFeed";
import Signals from "./pages/Signals";
import Insights from "./pages/Insights";
import InsightDetail from "./pages/InsightDetail";
import Opportunities from "./pages/Opportunities";
import OpportunityDetail from "./pages/OpportunityDetail";
import Simulation from "./pages/Simulation";
import LaunchIntel from "./pages/LaunchIntel";
import Ingestion from "./pages/Ingestion";
import Retraining from "./pages/Retraining";
import Projects from "./pages/Projects";
import Concepts from "./pages/Concepts";
import CulturalSignals from "./pages/CulturalSignals";
import OfflineSignals from "./pages/OfflineSignals";
import NeedScope from "./pages/NeedScope";
import Briefs from "./pages/Briefs";
import Suppliers from "./pages/Suppliers";
import RFPs from "./pages/RFPs";
import Validation from "./pages/Validation";
import Whitespace from "./pages/Whitespace";
import Learnings from "./pages/Learnings";
import Logs from "./pages/Logs";
import "./App.css";

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen bg-bm-bg flex items-center justify-center">
        <div className="font-mono text-xs text-bm-dim tracking-[0.3em] animate-pulse" data-testid="auth-checking">AUTHENTICATING…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="*"
            element={
              <Protected>
                <Layout>
                  <Routes>
                    <Route path="/" element={<HomeFeed />} />
                    <Route path="/signals" element={<Signals />} />
                    <Route path="/insights" element={<Insights />} />
                    <Route path="/insights/:id" element={<InsightDetail />} />
                    <Route path="/opportunities" element={<Opportunities />} />
                    <Route path="/opportunities/:id" element={<OpportunityDetail />} />
                    <Route path="/simulate" element={<Simulation />} />
                    <Route path="/launches" element={<LaunchIntel />} />
                    <Route path="/ingest" element={<Ingestion />} />
                    <Route path="/logs" element={<Logs />} />
                    <Route path="/retraining" element={<Retraining />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/projects/needscope" element={<NeedScope />} />
                    <Route path="/concepts" element={<Concepts />} />
                    <Route path="/cultural" element={<CulturalSignals />} />
                    <Route path="/offline-signals" element={<OfflineSignals />} />
                    <Route path="/briefs" element={<Briefs />} />
                    <Route path="/suppliers" element={<Suppliers />} />
                    <Route path="/rfps" element={<RFPs />} />
                    <Route path="/validation" element={<Validation />} />
                    <Route path="/whitespace" element={<Whitespace />} />
                    <Route path="/learnings" element={<Learnings />} />
                    <Route path="/team" element={<Team />} />
                  </Routes>
                </Layout>
              </Protected>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
